import React, { useState, useEffect } from "react";
import axios from "axios";
import EmployTable from "../../Utills/Table/EmployTable";
import EmployeeModal from "../../components/Modal/Employee";
import Switch from "@mui/material/Switch";
const EmployPage = ({ check, change }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [employ, setEmploy] = useState([]);

  useEffect(() => {
    if (loading) {
      axios
        .get("https://tsetsegtuw.templateapi.xyz/user?role=admin")
        .then((e) => setEmploy(e.data.data))
        .catch((e) => console.log(e))
        .finally(() => setLoading(false));
    }
  }, [loading]);

  if (loading) {
    return <div className="loader">...loader</div>;
  }

  return (
    <div className="flex flex-col items-center justify-start min-h-screen ml-[18vw] w-[80vw] p-6">

      <div className="w-full flex justify-end mb-4 items-center">
        <Switch
          checked={check}
          onChange={change}
          inputProps={{ "aria-label": "controlled" }}
        />
        <EmployeeModal />
      </div>
      <div className="w-full max-w-7xl">
        <EmployTable employs={employ} />
      </div>
    </div>
  );
};

export default EmployPage;
